<template>
  <div>
    <resume />
<!--    <old-resume />-->
  </div>
</template>

<script>
//   import oldResume from './editorCv/index'
  import resume from './cvsEditor/index'
	export default {
		name: 'index',
		data () {
			return {}
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {
			// oldResume,
      resume
    },
		methods: {}
	}
</script>

<style lang="scss" scoped>

</style>